<template>
  <div>
    <span class="variation-listing-filters-group-name">{{ group.variationGroupName }}</span>
    <div
      class="variation-listing-filters-variation-entries"
      :class="getVariationEntriesClassName"
    >
      <EntryFilter
        v-for="variationEntry in entries"
        :key="variationEntry.id"
        :entry="variationEntry"
        :group="group"
        class="variation-listing-filters-variation-entry"
      >
      </EntryFilter>
    </div>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  props: {
    group: {
      variationDisplayType: '',
      variationGroupId: '',
      variationGroupName: null,
      variationGroupStep: 0,
      variationGroupDisplayPosition: 0,
      variations: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getVariationEntriesClassName () {
      let className = ''
      if (!this.isBaseGroup) {
        className += 'range_group '
      }
      className += this.group.variationDisplayType
      return className
    }
  }
}
</script>
